import { Routes } from '@angular/router';
import { authGuard } from '@lib/auth/shell';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@lib/auth/shell').then((shell) => shell.LOGIN_ROUTES),
  },
  {
    path: 'deactivated',
    loadChildren: () => import('@lib/auth/shell').then((shell) => shell.DEACTIVATED_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('@lib/layout/shell').then((routes) => routes.MAIN_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
